module.exports = __webpack_public_path__ + "2202177a028b77b08702ea0312f7aa4b.png";